export default "__VITE_ASSET__lHO95bsk__"